import FeatureTiles from './FeatureTiles';

export default FeatureTiles;
